export enum DenialReason {
  MEDICAL_NECESSITY = "Not medically necessary",
  FORMULARY = "Not covered on formulary",
  SITE_OF_CARE = "Not covered at site of care",
  NETWORK = "Doctor not in network",
}
